import React from 'react';

const Map = () => {
    return (
        <section>
            <div className="map">
                <iframe
                    className="map-container"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.9081166310857!2d70.76535067529312!3d22.31931447967289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959c9e3e1a378a3%3A0xcc13a75e23cccd78!2sCode%20Buddy%27s!5e0!3m2!1sen!2sin!4v1783065849584!5m2!1sen!2sin%22"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Code Buddy's Location"
                ></iframe>
            </div>
        </section>
    );
};

export default Map;

 